import { Controller } from "react-hook-form";
import { Row, Col, Form } from "react-bootstrap";
import Select from "react-select";
// import ProductSection from "./ProductSection";
import { useEffect, useState } from "react";
import { getData } from "../../../utils/api";
import { Select2Data, variant_type } from "../../../utils/common";
import TripleVarientSection from "./TripleVarient";

const DoubleVarientSection = ({
  product_id,
  Index,
  control,
  register,
  getValues,
  errors,
  setValue,
  DoubleVariants,
  SIndex,
  baseName = "products",
}) => {
  const [categories, setCategories] = useState([]);

  const getAllCategories = async () => {
    const response = await getData("/common/masters/all-vendor-p-categories");
    if (response?.success) {
      setCategories(await Select2Data(response?.data, "p_category_id"));
    }
  };
  const [days, setDays] = useState([]);
  const getAllDays = async () => {
    const response = await getData("/common/masters/all-days");
    if (response?.success) {
      setDays(await Select2Data(response?.data, "day_id"));
    }
  };
  useEffect(() => {
    getAllCategories();
    getAllDays();
  }, []);

  const [productVarient, setProductVarient] = useState([]);

  const Select2Data = async (data, name, other = false) => {
    const result = data?.map((data) => ({
      value: data?.id,
      label: data?.name,
      price: data?.price,
      name: name,
    }));

    if (other) {
      result.push({ value: "0", label: "Other", name: name });
    }
    return result;
  };
  const GetAllProductVarient = async (id) => {
    const response = await getData(
      `/common/masters/product-varient/${product_id?.value}`,
    );

    if (response?.success) {
      setProductVarient(await Select2Data(response?.data, "varient_id"));
    }
  };

  useEffect(() => {
    GetAllProductVarient();
  }, [product_id?.value]);

  // useEffect(() => {
  //   const fetchAndAppendVariants = async () => {
  //     const response = await getData(
  //       `/common/masters/product-varient/${product_id?.value}`
  //     );

  //     if (response?.success) {
  //       const dvariants = await Select2Data(response?.data, "varient_id");
  //       setProductVarient(dvariants);

  //       // Clear existing dvariants if any
  //       while (productVarient.length) remove(0);

  //       // Append each dvariant with full object (value + label)
  //       dvariants.forEach((dvariant) => {
  //         append({
  //           varient_id: dvariant, // { value: x, label: "name" }
  //           quantity: "",
  //         });
  //       });
  //     }
  //   };

  //   fetchAndAppendVariants();
  // }, [product_id]);

  return (
    <>
      {DoubleVariants?.map((dvariant, DIndex) => (
        <div key={dvariant.value} className="border p-3 mb-3">
          <Row>
            <h5>Double Variant {DIndex + 1}</h5>

            {/* Hidden field to store varient_id */}
            <Controller
              control={control}
              name={`${baseName}.${Index}.varients.${SIndex}.double_variants.${DIndex}.d_variant_id`}
              defaultValue={dvariant?.id}
              render={({ field }) => <input type="hidden" {...field} />}
            />

            <Col md={4}>
              <Form.Group>
                <Form.Label>Size</Form.Label>

                <Form.Control
                  type="text"
                  value={dvariant.Size?.name}
                  readOnly
                />
              </Form.Group>
            </Col>

            {Number(product_id?.variant_type_id) === variant_type.Double && (
              <>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Selling Price</Form.Label>
                    <Controller
                      control={control}
                      name={`${baseName}.${Index}.varients.${SIndex}.double_variants.${DIndex}.selling_price`}
                      defaultValue={dvariant.price}
                      render={({ field }) => (
                        <Form.Control
                          {...field}
                          type="text"
                          readOnly
                          placeholder="Selling Price"
                          isInvalid={
                            !!errors?.[baseName]?.[Index]?.varients?.[SIndex]
                              ?.double_variants?.[DIndex]?.selling_price
                          }
                        />
                      )}
                    />
                    <Form.Control.Feedback type="invalid">
                      {
                        errors?.[baseName]?.[Index]?.varients?.[SIndex]
                          ?.double_variants?.[DIndex]?.selling_price?.message
                      }
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Stock</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder=" Stock"
                      {...register(
                        `${baseName}.${Index}.varients.${SIndex}.double_variants.${DIndex}.stock`,

                        {
                          required: " Stock is required",
                          validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less",
                        },
                      )}
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          "Backspace",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ];

                        // Allow only control keys and digits (0–9)
                        if (allowedKeys.includes(e.key) || /^\d$/.test(e.key)) {
                          return;
                        }

                        // Prevent decimal points or anything else
                        e.preventDefault();
                      }}
                     
                    />
                    <Form.Control.Feedback type="invalid">
                      {
                        errors?.[baseName]?.[Index]?.varients?.[SIndex]
                          ?.double_variants?.[DIndex]?.stock?.message
                      }
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>{" "}
              </>
            )}
            {dvariant?.Triple_Variants?.length > 0 && (
              <TripleVarientSection
                TripleVariants={dvariant?.Triple_Variants}
                product_id={product_id}
                Index={Index}
                SIndex={SIndex}
                DIndex={DIndex}
                control={control}
                register={register}
                getValues={getValues}
                errors={errors}
                setValue={setValue}
                baseName={baseName}
              />
            )}
          </Row>
        </div>
      ))}
    </>
  );
};

export default DoubleVarientSection;
